<div class="w-full flex items-center justify-center gap-2">
  <button
    type="button"
    class="pagination-btn pagination-btn-primary"
    [disabled]="isFirstPage"
    (click)="firstPageClick.emit()"
    title="Primeira página"
  >
    <l-icon class="!text-xl">keyboard_double_arrow_left</l-icon>
  </button>

  <button
    type="button"
    class="pagination-btn !bg-lGray850"
    [disabled]="isFirstPage"
    (click)="prevPageClick.emit()"
    title="Página anterior"
  >
    <l-icon class="!text-3xl">chevron_left</l-icon>
  </button>

  <span class="pagination-page-count">
    {{ currentPage }} de {{ totalPages }}
  </span>

  <button
    type="button"
    class="pagination-btn !bg-lGray850"
    [disabled]="isLastPage"
    (click)="nextPageClick.emit()"
    title="Próxima página"
  >
    <l-icon class="!text-3xl">chevron_right</l-icon>
  </button>

  <button
    type="button"
    class="pagination-btn pagination-btn-primary"
    [disabled]="isLastPage"
    (click)="lastPageClick.emit()"
    title="Última página"
  >
    <l-icon class="!text-xl">keyboard_double_arrow_right</l-icon>
  </button>
</div>
